import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CertificateDownloadForm from './CertificateDownloadForm';
import CustomDialog from '../dialogs/CustomDialog';
import AccountDownloadTile from '../account/AccountDownloadTile';
import GenerateEventCertificateMutation from '../../../mutations/GenerateEventCertificateMutation';
import environment from '../../../environment';
import { CERTIFICATE_SELECTED_PHOTO, CERTIFICATE_FACE } from '../../../utils/variables';

const ThumbnailPreviewCertificateDownload = (props) => {
  const { photoNodeId, startNumbers, isFaceSearchEvent, eventSgId } = props;

  const [optionsOpened, setOptionsOpened] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [failed, setFailed] = useState(false);

  const handleCloseOptions = () => {
    setOptionsOpened(false);
  };

  const handleOpenOptions = () => {
    if (failed) {
      setFailed(false);
    }
    setOptionsOpened(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  const openDialog = () => {
    setDialogOpen(true);
  };

  const handleDownloadCertificate = (startNumber) => {
    addToPendingArray(startNumber);
    GenerateEventCertificateMutation.commit(
      environment,
      eventSgId,
      photoNodeId,
      startNumber,
      (error, url) => {
        if (!error) {
          setFailed(false);
          download(url);
        } else {
          setFailed(true);
        }
        removeFromPendingArray(startNumber);
      }
    );
  };

  const download = (url) => {
    window.location.href = url;
  };

  const addToPendingArray = (startNumber) => {
    let newArr = [...pendingRequests];
    newArr.push(startNumber);
    setPendingRequests(newArr);
  };

  const removeFromPendingArray = (startNumber) => {
    const newArr = pendingRequests.filter((item) => item !== startNumber);
    setPendingRequests(newArr);
  };

  const defineMainAction = () => {
    if (startNumbers.length > 1) {
      handleOpenOptions();
      return;
    } else {
      handleDownloadCertificate(startNumbers[0]);
      return;
    }
  };

  return (
    <div className='thumbnail-btn-wrapper'>
      {startNumbers && !isFaceSearchEvent && (
        <AccountDownloadTile
          type={CERTIFICATE_SELECTED_PHOTO}
          onCertificateDownloadClick={() => defineMainAction()}
          hasOpenedOptions={optionsOpened}
          hasOptions={startNumbers.length > 1}
          onCloseOptions={handleCloseOptions}
          isPending={pendingRequests.length > 0}
          isError={failed}
        >
          {optionsOpened && (
            <div className="dropdown">
              {startNumbers.map((sn) => {
                return (
                  <button
                    key={sn}
                    onClick={() => {
                      handleDownloadCertificate(sn);
                      handleCloseOptions();
                    }}
                    className="dropdown-item"
                  >
                    {sn}
                  </button>
                );
              })}
            </div>
          )}
        </AccountDownloadTile>
      )}
      {isFaceSearchEvent && (
        <>
          <AccountDownloadTile
            type={CERTIFICATE_FACE}
            onOpenCertificateDialog={openDialog}
          />
          <CustomDialog open={dialogOpen} onRequestClose={closeDialog}>
            <CertificateDownloadForm
              onDownloadCertificate={handleDownloadCertificate}
              pendingRequests={pendingRequests}
              failed={failed}
            />
          </CustomDialog>
        </>
      )}
    </div>
  );
};

ThumbnailPreviewCertificateDownload.propTypes = {
  photoNodeId: PropTypes.string,
  startNumbers: PropTypes.array,
  isFaceSearchEvent: PropTypes.bool,
  eventSgId: PropTypes.number,
};

export default ThumbnailPreviewCertificateDownload;
export { ThumbnailPreviewCertificateDownload };
